import { ValidationError, FetchFailedError, ErrorCode} from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import { rugbyLogsApiResponse, RugbyTable, RugbyMatchDetail, rugbyMatchDetail } from './validators/rugby_logs';

export interface RugbyAPI {
  fetchRugbyLogs: (slug: string) => Promise<RugbyTable>;
  fetchRugbyMatchDetails: (slug: number) => Promise<RugbyMatchDetail>;
}

export class RugbyApi extends RawApi implements RugbyAPI {
  public async fetchRugbyLogs(
    slug: string,
  ): Promise<RugbyTable> {
    const response = await this.fetchScoresApi(`/rugby/v4/${slug}/logs`);
    if (!response.ok) {
      throw new FetchFailedError(response.statusText, response.status as ErrorCode, response);
    }
    const jsonResponse: unknown = await response.json();
    const tableLogs = rugbyLogsApiResponse.decode(jsonResponse);

    if (isLeft(tableLogs)) {
      throw new ValidationError('API Response validation failed', 400, tableLogs);
    }

    return tableLogs.right;
  }

  public async fetchRugbyMatchDetails(
    slug: number,
  ): Promise<RugbyMatchDetail> {
    const response = await this.fetchScoresApi(`/rugby/v4/matchdetails/${slug}`);
    if (!response.ok) {
      throw new FetchFailedError(response.statusText, response.status as ErrorCode, response);
    }
    const jsonResponse: unknown = await response.json();
    const matchDetails = rugbyMatchDetail.decode(jsonResponse);

    if (isLeft(matchDetails)) {
      throw new ValidationError('API Response validation failed', 400, matchDetails);
    }

    return matchDetails.right;
  }
}
